// 初回ログイン時のガイダンスのフェーズ
const GUIDE_PHASE = {
  // 中心座標登録
  GUIDE_ADD_HOME_MARKER: 0,
  // 田圃登録紹介
  GUIDE_PADDY_FIELD_ADD: 1,
  // 作業項目紹介
  GUIDE_WORKITEM_EDIT: 2,
  // ガイダンス終了
  GUIDE_FINISHED: 999
};

// メッセージダイアログの種類
const DIALOG_TYPE = {
  MESSAGE: 1,
  CONFIRM: 2
};

export { GUIDE_PHASE, DIALOG_TYPE };
